import React from 'react';
import { Skeleton } from 'primereact/skeleton';

interface DashboardWidgetProps {
  title: string;
  icon: string;
  iconColor: string;
  children: React.ReactNode;
  loading?: boolean;
  badge?: number | string | null;
  onViewAll?: () => void;
  viewAllLabel?: string;
  minHeight?: string;
}

export const DashboardWidget: React.FC<DashboardWidgetProps> = ({
  title,
  icon,
  iconColor,
  children,
  loading = false,
  badge,
  onViewAll,
  viewAllLabel = 'Ver todo',
  minHeight = '280px'
}) => {
  return (
    <div
      style={{
        background: 'var(--ios-card-bg)',
        borderRadius: 'var(--ios-radius-xl)',
        border: '1px solid var(--ios-card-border)',
        boxShadow: 'var(--ios-card-shadow)',
        overflow: 'hidden',
        minHeight,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <div
        className="flex align-items-center justify-content-between"
        style={{
          padding: '0.75rem 1rem',
          borderBottom: '1px solid var(--ios-card-border)'
        }}
      >
        <div className="flex align-items-center gap-2">
          <div
            style={{
              width: '2rem',
              height: '2rem',
              borderRadius: 'var(--ios-radius-md)',
              background: `${iconColor}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <i className={icon} style={{ color: iconColor, fontSize: '0.9rem' }} />
          </div>
          <span
            style={{
              fontWeight: 700,
              fontSize: '0.85rem',
              color: 'var(--ios-text)',
              letterSpacing: '-0.01em'
            }}
          >
            {title}
          </span>
          {badge !== null && badge !== undefined && (
            <span
              style={{
                background: `${iconColor}20`,
                color: iconColor,
                borderRadius: 'var(--ios-radius-pill)',
                padding: '0.1rem 0.5rem',
                fontSize: '0.7rem',
                fontWeight: 700
              }}
            >
              {badge}
            </span>
          )}
        </div>
        {onViewAll && (
          <button
            onClick={onViewAll}
            style={{
              background: 'none',
              border: 'none',
              color: '#4d7c0f',
              fontSize: '0.75rem',
              fontWeight: 600,
              cursor: 'pointer',
              padding: '0.2rem 0.4rem',
              borderRadius: 'var(--ios-radius-sm)'
            }}
          >
            {viewAllLabel}
          </button>
        )}
      </div>

      {/* Body */}
      <div style={{ padding: '0.75rem 1rem', flex: 1, overflow: 'auto' }}>
        {loading ? (
          <div className="flex flex-column gap-2">
            <Skeleton height="1.5rem" />
            <Skeleton height="1.5rem" />
            <Skeleton height="1.5rem" />
            <Skeleton height="1.5rem" />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
